import { useContext, useEffect, useState } from 'react'
import catchError from '../../../components/global/CatchError'
import Loader from '../../../components/global/Loader'
import Title from '../../../components/global/Title'
import { sweetAlertSuccess } from '../../../components/sweetalert/Alert'
import Table from '../../../components/table/Table'
import UserContext from '../../../context/UserContext'
import { useLangSelected } from '../../../hooks/useLangSelected'
import { useVerifyAdminToken } from '../../../hooks/useVerifyAdminToken'
import apiClient from '../../../services/apiClient'
import { serverFile } from '../../../services/file.service'
import { PartnerModel } from '../../../types/partner.type'
import { AdminContainer, LinkBtn, TitleWrapper } from '../users/AdminUsers'

const getServerFile = (partnerItem: PartnerModel) => {
    if (!partnerItem.logo) return ''
    if (partnerItem.logo.startsWith('http')) return partnerItem.logo
    return serverFile(partnerItem.logo)
}
const filterValue = (partners: PartnerModel[], res: any) =>
    partners.filter((partnerData) => partnerData.id !== res.data.id)

const AdminPartners = () => {
    const user = useContext(UserContext)
    const [partners, setPartners] = useState<PartnerModel[] | undefined>(undefined)

    const verifyToken = useVerifyAdminToken()
    const lng = useLangSelected()

    const [currentLang, setCurrentLang] = useState(lng)

    const tableHeader = ['#', 'Nom', 'Description', 'Logo', 'Lien', 'Ordre', '', '']

    useEffect(() => {
        verifyToken()
        if (!partners || currentLang !== lng) {
            setCurrentLang(lng)
            apiClient
                .post('/partners/all', { lng })
                .then(({ data }) => {
                    setPartners(
                        data.map((partnerItem: PartnerModel) => {
                            const logoUrl = getServerFile(partnerItem)
                            return {
                                id: partnerItem.id,
                                name: partnerItem.name,
                                description: partnerItem.description || '',
                                logo: [
                                    logoUrl ? (
                                        <a href={logoUrl} target="_blank" rel="noreferrer">
                                            <img src={logoUrl} alt={partnerItem.name} style={{ height: '38px' }} />
                                        </a>
                                    ) : (
                                        ''
                                    ),
                                ],
                                link: partnerItem.link || '',
                                order: partnerItem.order,
                                edit: `/${lng}/bva-admin/partenaires/${partnerItem.id}`,
                                remove: true,
                            }
                        }),
                    )
                })
                .catch((err) =>
                    catchError(err.response.data, () => {
                        window.location.reload()
                    }),
                )
        }
    }, [partners, user, lng])

    if (!partners) return <Loader />

    const deleteById = (id: number) => {
        verifyToken()
        apiClient
            .delete(`/partners/${id}`)
            .then((res) => {
                sweetAlertSuccess('La suppression de ce partenaire est réussie').then(() => {
                    setPartners([...filterValue(partners, res)])
                })
            })
            .catch((err) =>
                catchError(err.response.data, () => {
                    window.location.reload()
                }),
            )
    }

    return (
        <>
            <TitleWrapper>
                <Title dataTestId="title">Partenaires</Title>
                <LinkBtn to={`/${lng}/bva-admin/partenaires/creer`} className="btn btn-primary mb-2">
                    Créer
                </LinkBtn>
            </TitleWrapper>
            <AdminContainer>
                <Table tableData={partners} tableHeader={tableHeader} deleteById={deleteById} />
            </AdminContainer>
        </>
    )
}

export default AdminPartners
